import type { TodaySlot } from '@/types/bootstrap';

/**
 * TodaysPlan — pure slot renderer.
 *
 * One section per slot: mono-caps eyebrow ("PM", "ANY TIME") followed by
 * one full-width hairline-bordered card per medication (mono-caps name +
 * body dose subtitle). Caller (HomeScreen) owns the section header,
 * status copy, and empty-state messaging via PageHeader description.
 * Renders nothing when there are no slots.
 */
export function TodaysPlan({ slots }: { slots: TodaySlot[] }) {
  if (slots.length === 0) return null;

  return (
    <div className="flex flex-col gap-20">
      {slots.map((slot) => (
        <div key={slot.slot} className="flex flex-col gap-10">
          <h3 className="font-mono text-12 uppercase text-[#7C7C7C]">
            {slot.name}
          </h3>
          <ul className="flex flex-col gap-10">
            {slot.medications.map((m) => (
              <li
                key={m.medication_id}
                className="border border-[#ECECEC] bg-white px-15 py-15 flex flex-col gap-5"
              >
                <div className="font-mono text-15 uppercase text-black leading-110">
                  {m.medication_name}
                </div>
                <div className="font-body text-13 text-[#7C7C7C]">
                  {m.dose}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
